import React from 'react';

const Sponsors = () => {
  const sponsorList = [
    { name: "Oceanic Sails",      logo: "/images/sponsor_oceanic_sails.png" },
    { name: "Harbor Bank",        logo: "/images/sponsor_harbor_bank.png" },
    { name: "Anchor Beverages",   logo: "/images/sponsor_anchor_beverages.png" },
    { name: "Marine Tech",        logo: "/images/sponsor_marine_tech.png" },
  ];

  return (
    <div className="sponsors-section">
      <h3>Our Proud Sponsors</h3>
      <div className="sponsor-grid">
        {sponsorList.map((sponsor, index) => (
          <div key={index} className="sponsor-card">
            <img src={sponsor.logo} alt={sponsor.name} title={sponsor.name} />
            <p className="sponsor-name">{sponsor.name}</p>
          </div>
        ))}
      </div>
      <p className="sponsor-footer">
        Interested in sponsoring the 2026 Regatta?{' '}
        <a href="mailto:info@jeklabs.com">Contact us</a>
      </p>
    </div>
  );
};

export default Sponsors;
